import { render, staticRenderFns } from "./Url.vue?vue&type=template&id=2721a00e&scoped=true&"
import script from "./Url.vue?vue&type=script&lang=js&"
export * from "./Url.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2721a00e",
  null
  
)

export default component.exports